import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function TopLists() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Explore curated top lists of dining experiences on First-Class.com. Find the best restaurants, cuisines, and culinary adventures'
          }
        />
        <title>Dining Toplists: Ranking the Best Dining Experiences</title>
      </Head>
      <ArticlesList
        subtype="Toplists"
        type="Dining"
        heading="Finest Selection"
      />
    </>
  );
}

export default withLayout(TopLists, true);
